// <details> is the accessible choice for the navbar dropdown - tabbable and
// toggled by Enter and Space - but natively it only closes via its own summary.
// These listeners add the outside-click and Escape behaviour people expect.
//
// The fourth navbar menu to need exactly these three listeners, after
// userMenu.js, aufgabenGlocke.js and globalSuche.js. Those three say they are
// copied rather than shared because two, then three, menus needing the same
// handful of lines is not yet shared behaviour. Four is: the next menu added
// here should lift all of them into one `dropdownSchliessen(menu)` helper in
// shared/ rather than paste these lines a fifth time.
export function initVerwaltungMenu() {
  const menu = document.getElementById('verwaltung-menu');
  if (!menu) return;

  const close = () => menu.removeAttribute('open');

  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target)) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !menu.hasAttribute('open')) return;
    close();
    menu.querySelector('summary')?.focus();
  });

  // A menu item navigates to its page; the panel should not stay open behind
  // it.
  menu.querySelector('.dropdown-content')?.addEventListener('click', close);
}
